let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dBjkU")).then(() => parcelRequire('ln6ck'));